import CircularProgress from "@mui/material/CircularProgress";
import { TextField, TextFieldProps } from "@mui/material";

export type ValidationStatus = "idle" | "loading" | "valid" | "invalid" | "error";

interface ValidationTextFieldProps extends Omit<TextFieldProps, "error"> {
  status: ValidationStatus;
  loadingIndicator?: React.ReactNode;
}

const VALIDATION_COLORS = {
  valid: "#16A34A",
} as const;

export const ValidationTextField: React.FC<ValidationTextFieldProps> = ({
  status,
  loadingIndicator = <CircularProgress size={20} />,
  helperText,
  sx,
  ...props
}) => {
  const isError = status === "invalid" || status === "error";
  const validColor = VALIDATION_COLORS.valid;

  return (
    <TextField
      {...props}
      error={isError}
      helperText={helperText}
      sx={{
        ...sx,
        "& .MuiOutlinedInput-root": {
          ...(status === "valid" && {
            "& fieldset": { borderColor: validColor },
            "&:hover fieldset": { borderColor: validColor },
            "&.Mui-focused fieldset": { borderColor: validColor },
            color: validColor,
          }),
        },
        "& .MuiInputLabel-root": {
          ...(status === "valid" && { color: validColor }),
        },
        "& .MuiFormHelperText-root": {
          ...(status === "valid" && { color: validColor }),
        },
      }}
      InputProps={{
        ...(props.InputProps ?? {}),
        endAdornment: status === "loading" ? loadingIndicator : props.InputProps?.endAdornment,
      }}
    />
  );
};
